import api from 'api';

const path = 'api/events';

export default {
    fetch: params => api.get({path, params: {...params, passed: 0}})
}